<template>
  <div>
    <v-row class="d-flex justify-center align-center ma-4">
      <v-progress-circular indeterminate :size="this.size" :width="this.width" color="primary"></v-progress-circular>
      <div class="ma-4"></div>
    </v-row>
    <v-row class="d-flex justify-center align-center ma-4">
      <template v-if="this.customText != ''">
        <h4>{{ this.customText }}</h4>
      </template>
      <template v-else>
        <h4>{{ $t("loadingData") }}</h4>
      </template>
    </v-row>
  </div>
</template>

<script>
export default {
  name: "LoadingData",
  props: {
    size: {
      type: Number,
      default: 325,
      required: false,
    },
    width: {
      type: Number,
      default: 12,
      required: false,
    },
    customText: {
      type: String,
      default: "",
      required: false,
    },
  },
};
</script>
